import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '@/store';
import { Store, User } from '@/interfaces';


interface Slice {
  user: User | null;
  currentUser: User | Store | null;
  storeList: Partial<Store>[];
  loading: boolean;
}

const initialState: Slice = {
  user: null,
  currentUser: null,
  storeList: [],
  loading: false,
};
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, {payload}: PayloadAction<User>) => {
      state.user = payload;
    },
    removeUser: state => {
      state.user = null;
    },
    setCurrentUser: (state, {payload}: PayloadAction<User | Store| null>) => {
      state.currentUser = payload;
    },
    removeCurrentUser: state => {
      state.currentUser = null;
    },
    setStoreList: (state, {payload}: PayloadAction<Partial<Store>[]>) => {
      state.storeList = payload;
    },
    removeStoreList: state => {
      state.storeList = [];
    },
    setLoading: (state, {payload}: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    clearAll: state => {
      state.user = null;
      state.currentUser = null;
      state.storeList = [];
      state.loading = false;
    },
  },
});
export const {
  setUser,
  removeCurrentUser,
  removeUser,
  setCurrentUser,
  setStoreList,
  removeStoreList,
  clearAll,
  setLoading,
} = authSlice.actions;
export const userSelector = (state: RootState) => state.auth.user;
export const storeListSelector = (state: RootState) => state.auth.storeList;
export const currentUserSelector = (state: RootState) => state.auth.currentUser;
export const emailSelector = (state: RootState) =>
  state.auth.currentUser?.email;
export const phoneNumberListSelector = (state: RootState) =>
  state.auth?.user?.phoneNumber;
export const profileTypeSelector = (state: RootState) =>
  state.auth.currentUser?.profileType;
export const userRoleSelector = (state: RootState) =>
  state.auth.currentUser?.role;

export const loadingSelector = (state: RootState) => state.auth.loading;

export default authSlice.reducer;
